import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const EMOJIS = [
  { key: "fire", char: "🔥", label: "Hype" },
  { key: "sword", char: "⚔️", label: "War" },
  { key: "target", char: "🎯", label: "Called it" },
  { key: "shield", char: "🛡️", label: "Defensive" },
  { key: "clown", char: "🤡", label: "Copium" },
];

/**
 * Compact reaction bar for fixture cards. Anonymous users see counts,
 * logged-in users can vote (one reaction each, latest wins).
 */
export default function MatchReactions({ fixtureId, compact = false }) {
  const { user } = useAuth();
  const [counts, setCounts] = useState({});
  const [mine, setMine] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/fixtures/${fixtureId}/reactions`)
      .then((r) => {
        if (cancelled) return;
        setCounts(r.data?.counts || {});
        setMine(r.data?.mine || null);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [fixtureId]);

  const vote = async (key) => {
    if (!user) {
      toast.error("Log in to react");
      return;
    }
    try {
      const r = await api.post(`/fixtures/${fixtureId}/reactions`, { emoji: key });
      setCounts(r.data?.counts || {});
      setMine(r.data?.mine || null);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reaction failed");
    }
  };

  return (
    <div className={`flex items-center gap-1 ${compact ? "" : "flex-wrap"}`} data-testid={`reactions-${fixtureId}`}>
      {EMOJIS.map((e) => {
        const c = counts[e.key] || 0;
        const isMine = mine === e.key;
        return (
          <button
            key={e.key}
            onClick={(ev) => { ev.stopPropagation(); ev.preventDefault(); vote(e.key); }}
            data-testid={`reaction-${e.key}-${fixtureId}`}
            title={e.label}
            className={`flex items-center gap-1 px-2 py-1 border text-xs font-mono transition-colors ${
              isMine
                ? "border-[#F4D03F] bg-[#F4D03F]/10 text-[#F4D03F]"
                : "border-[#232330] text-gray-400 hover:border-white hover:text-white"
            }`}
          >
            <span className="text-sm">{e.char}</span>
            <span className="tabular-nums">{c}</span>
          </button>
        );
      })}
    </div>
  );
}
